

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { showModal, showNestedModal } from "../../features/modal/modalSlice"
import Button from "../shared/Button"
import { resetStatusCode } from "../../features/admin/adminSlice"
import { Link, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import ResultSuccessTickMark from "../shared/ResultSuccessTickMark"
import ResultErrorXMark from "../shared/ResultErrorXMark"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p{
            font-size: 16px;
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 30px 0;
        }

        .link{
            background-color: #E85446;
            color: #fff;
            width: 310px;
            border-radius: 10px;
            width: ${({width})=> width};
            padding: 12px;
            text-align: center;
            font-size: 16px;
            line-height: 1;
            font-weight: var(--font-weight-md);
        }

    }
`


const NestedResultModal = () => {
    
    const {resultModalData} = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        const timer = setTimeout(() => {
            if(resultModalData?.resultType === "success"){
                dispatch(showNestedModal(null));
                if(resultModalData?.routePath){
                    navigate(resultModalData?.routePath)
                }
            }
        }, 1500);
        return () => clearTimeout(timer);
      }, [resultModalData?.resultType]);


    if(!resultModalData){
        return null
    }

    //! belki burada api den gelen olumlu ya da olumsuz cevaba göre farklı components lar render edilebilir.( belki bu sayede şu gıcık svg renk değiştirme sorunu çözülür.) ***********************************************************
    
  return (
    <Container onClick={()=> showNestedModal(null)}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            {
                resultModalData.resultType === "success"?
                <ResultSuccessTickMark/>:
                <ResultErrorXMark/>
            }
            <p>{resultModalData.msg}</p>
            {
                resultModalData.routePath ? 
                <Link to={resultModalData.routePath} className="link" onClick={() => dispatch(showModal(null))}>{resultModalData.btnText1}</Link>:
                <Button text={resultModalData.btnText1} background={"#E85446"} handleClick={()=> {dispatch(showNestedModal(null)); dispatch(resetStatusCode())}}/>
            }
        </div>
    </Container>
  )
}

export default NestedResultModal